import { AxiosError } from "axios";

export interface MdmApiError {
  type?: string;
  status?: number;
  title?: string;
  detail?: string;
}

export const mdmApiErrorMessageOrFallbackMessage = (
  axiosError: AxiosError<MdmApiError>,
  fallbackMessage: string
) => axiosError.response?.data.title ?? fallbackMessage;
